import createSvgIcon from "./utils/create_icon"

const FaqOutline = createSvgIcon(<><g fill="currentColor"><path d="M12 7a3 3 0 0 1 1 5.83V13a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1 1 1 0 1 0-1-1 1 1 0 1 1-2 0 3 3 0 0 1 3-3zm1 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" /><path clipRule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0z" fillRule="evenodd" /></g></>, "FaqOutline")
export default FaqOutline
